import { render } from "./FacetesFilter.vue?vue&type=template&id=1427fd23&scoped=true"
import script from "./FacetesFilter.vue?vue&type=script&lang=js"
export * from "./FacetesFilter.vue?vue&type=script&lang=js"

import "./FacetesFilter.vue?vue&type=style&index=0&id=1427fd23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1427fd23"]])

export default __exports__